<template>
  <div class="container">
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/mdrive-maritime-file-sharing"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/mDrive.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  mDrive Maritime File Sharing
                </h2>
              </strong>
              mDrive Storage Sync Solution simplifies file sync between onshore
              management and vessels. Enjoy secure cloud-based file
              synchronization with selected vessels.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/ticket-management-system-for-vessel-owners"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/tick.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>Ticket Management System for vessel owners</h2>
              </strong>
              Allows you to easily track and manage all of your vessel tickets
              in one place. Easily scale and streamline your customer service
              and drastically improve your customer's experience. Enjoy the
              adaptability and extensibility of IT Service Management System
              which is specially developed to suit work flow of Maritime
              industry.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/esign-for-marine-industry"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/esing.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>MariSign</h2>
              </strong>
              MariSign is an electronic signature software with unlimited
              electronic signatures, secure document management and supports
              folder based workflow management all for one simple price.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/maritech-file-sharing"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/Maritech-File-Sharing.webp')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>Maritech File Sharing</h2>
              </strong>
              Maritech provides comprehensive IT solutions designed for marine
              and offshore operations. Our services ensure seamless
              connectivity, data security, and efficient digital transformation
              to enhance your business operations.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/secure-private-document-management"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/Document-Management.webp')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  Secure Private Document Management with eSign Capability
                </h2>
              </strong>
              Keep your documents safe, organized, and easy to sign with our
              system. It ensures secure access, automated controls, and seamless
              eSign capability—perfect for managing documents effortlessly.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/secure-credential-sharing"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/Secure-Sharing.webp')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  Secure Sharing Solution for Marine Industry
                </h2>
              </strong>
              Ensure secure credential exchange in the marine industry with our
              Secure Sharing solution. Whether onshore or offshore, share
              sensitive data like passwords and login details with encryption,
              set expiration dates, and guarantee it's only seen by the intended
              recipient
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>

    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/genai-for-marine-industry"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/MarineAI.webp')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  MarineAI: Elevating Your Possible with Generative AI
                </h2>
              </strong>
              We help businesses scale and transform with cutting-edge AI
              technology that delivers real-world results. Let us elevate your
              enterprise potential with our tailored and trusted Generative AI
              solutions.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/vessel-communication-system"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/communicatonvessel.webp')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  Revolutionize Vessel Communication with Our Display System
                </h2>
              </strong>
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/ai-ship-inspection-solution"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/AIShip.webp')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  AI-Powered Ship Inspection
                </h2>
              </strong>
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/energy-efficiency-management-platform"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/Efficiency.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  Energy Efficiency Management Platform for Shipping Companies
                </h2>
              </strong>
              Our Energy Efficiency Management Platform empowers you to record
              zero carbon emission journeys and gain invaluable insights that
              not only enhance your environmental impact but also drive
              operational efficiency
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/sefarer-email-services"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/mMail.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  mMail: Smart Maritech Mail - Reliable, Secure, Affordable
                </h2>
              </strong>
              A maritime business email solution, Smart Maritech Mail, offering
              reliability, security, and affordability. At Maritech IT
              Solutions, we embark on a transformative journey to enhance
              communication and streamline operations for seafarers worldwide.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        id="solutionname"
        :to="{ path: '/cloud-native-erp-system-for-the-maritime-industry' }"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/erp.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>Cloud-Native ERP System for the Maritime Industry</h2>
              </strong>
              Our company is developing a cutting-edge Enterprise Resource
              Planning (ERP) system specifically designed for the maritime
              industry.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        id="solutionname"
        :to="{ path: '/vessel-insights' }"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/dataai.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong> <h2>Greater insights to ship data using AI</h2> </strong>
              The new data access system will make it easier for ship owners and
              operators to track their vessels and make informed decisions.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        id="solutionname"
        :to="{ path: '/charter-book-system-for-commercial-department' }"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/solutions1.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong> <h2>Charter Book</h2> </strong>
              Let's agree that commercial department is wasting so much time
              toiling around with excel sheets. Makes more human errors
              (calculating dates, daily, monthly rentals). Our system helps
              commercial department to present actual status of how fleets are
              generating money.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :to="{ path: '/supplier-e-enrollment-form' }"
        :class="{ 'on-hover': hover }"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/solutions2.png')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  Supplier Management and Risk Assessment System with Integrated
                  ESG Questionnaire
                </h2>
              </strong>
              Streamline supplier management with our integrated solution,
              combining ESG questionnaire creation, risk assessment, and ERP
              system integration. Drive sustainability initiatives, gain
              actionable insights with PowerBI, and enjoy flexible hosting
              options and unlimited licenses.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <!-- <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/solutions3.jpg')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong> <h2>AI/ML for Invoice Processing</h2> </strong>
              <br />
              Business software vendors use Artificial Intelligence for invoice
              processing in several ways.
            </p>
            <div style="padding-left: 20px">
              <b>Our AI based software supports:</b>
              <ul>
                <li>Invoice Separation</li>
                <li>Data Extraction</li>
                <li>ERP Integration</li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-hover> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
